$('.carousel-responsive').on('slide.bs.carousel', function (e) {
    let itemsPerSlide = 7

    let idx = $(e.relatedTarget).index()

    let carrouselInner = e.target.querySelector('.carousel-inner')

    let totalItems = e.target.querySelectorAll('.carousel-item').length

    if (idx >= totalItems - (itemsPerSlide - 1)) {
        let it = itemsPerSlide - (totalItems - idx)

        for (let i = 0; i < it; i++) {
            carrouselInner.append(e.target.querySelectorAll('.carousel-item')[e.direction === "left" ? i : 0])
        }
    }
});
